import React from "react";
// Wrapper for cancel.svg image created for fill and stoke color dynamically set
const CancelIcon = props => {
    const {width, height, focused, pointer, onClick} = props
    return (
        <svg width={width} height={height} viewBox="0 0 120 120" version="1.1" xmlns="http://www.w3.org/2000/svg" class={pointer} onClick={onClick}>
            <title>Cancel</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Assets_icone" transform="translate(-1625.000000, -7816.000000)">
                    <g id="Cancel" transform="translate(1625.000000, 7816.000000)">
                        <circle id="Oval" class={focused ? "search-bar-icon-focused" : "search-bar-icon-not-focused"} cx="60" cy="60" r="60"></circle>
                        <g id="Group-2" transform="translate(39.000000, 39.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="8.37209302">
                            <line x1="0" y1="0" x2="41.8604651" y2="41.8604651" id="Path-6"></line>
                            <line x1="41.8604651" y1="0" x2="0" y2="41.8604651" id="Path-6"></line>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default CancelIcon